import { CarouselItem } from '../components/MediaCarousel';

export const realisationsSlides: CarouselItem[] = [
  {
    src: '/assets/realisations/img_bus_ofc.jpg',
    alt: 'Bus OFC Adiaké habillé par Digiprint',
    title: 'Covering complet du bus — Olympique FC d’Adiaké',
    description:
      'Digiprint a conçu et posé le covering intégral du bus de l’OFC Adiaké pour une visibilité impactante.',
    badge: 'Grand format',
  },
  {
    src: 'https://public.youware.com/image/f9a2d098-f865-4385-85f0-1a16de786b47/vhk6rg9dur.jpg',
    alt: 'Kakemonos 75 ans PAA imprimés par Digiprint',
    title: 'Supports événementiels — 75 ans du PAA',
    description:
      'Conception et impression de kakémonos premium pour l’anniversaire des 75 ans du Port Autonome d’Abidjan.',
  },
  {
    src: 'https://public.youware.com/image/8e7fdbd5-0a1d-4513-a40b-ea6615cf8576/v0u5wny7bj.png',
    alt: 'Roll-up PAA “Hub port en Afrique” par Digiprint',
    title: 'Branding institutionnel — PAA',
    description:
      'Impression grand format et finitions de qualité pour une communication institutionnelle cohérente.',
  },
  {
    src: 'https://public.youware.com/image/f5233024-2b18-4208-b285-8a4916a91a9c/5s7tlissuw.jpg',
    alt: 'Cérémonie 60 ans BAD — brochure imprimée Digiprint',
    title: 'Supports de communication — 60 ans de la BAD',
    description:
      'Production de supports imprimés premium pour la célébration officielle des 60 ans de la BAD.',
  },
  {
    src: 'https://public.youware.com/image/df4bf8b3-d1ab-4349-9cf0-ee07ca22c435/jmloq1u6jl.jpg',
    alt: 'Brochure officielle 60 ans BAD — Digiprint',
    title: 'Événementiel premium — BAD',
    description:
      'Accompagnement impression & présentation pour une image cohérente lors des célébrations de la BAD.',
  },
];
